import React, { useState } from "react";
import request from "request";
import Card from "Card";
import Input from "Input";
import Button from "Button";
import Icon from "Icon";
import PrepaidCreditCard from "./PrepaidCreditCard";

const CheckBarcodeTab = ({ dataSource = "internal" }) => {
  const [barcode, setBarcode] = useState("");
  const [barcodeResults, setBarcodeResults] = useState(null);
  const [isScanning, setIsScanning] = useState(false);

  const handleBarcodeCheck = () => {
    setIsScanning(true);

    let req = request.get(`${dataSource}/prepaid_credits?code=${barcode}`);
    req.then(({data}) => {
      if (data && data.pageData && data.pageData.length > 0) {
        setBarcodeResults(data.pageData);
        setIsScanning(false);
      } else {
        setBarcodeResults({ error: "No credits found with this code" });
        setIsScanning(false);
      }
    }).catch(error => {
      setBarcodeResults({ error: "Error searching for credits" });
      setIsScanning(false);
    });
  };

  return (
    <div className="column is-12">
      <Card title="Check Barcode">
        <div className="field has-addons">
          <div className="control is-expanded">
            <Input
              placeholder="Enter barcode or credit code"
              value={barcode}
              onChange={setBarcode}
            />
          </div>
          <div className="control">
            <Button
              className="is-primary"
              onClick={handleBarcodeCheck}
              disabled={isScanning || !barcode}
              icon="search"
              text={isScanning ? "Scanning..." : "Check"}
            />
          </div>
        </div>

        {barcodeResults && barcodeResults.error && (
          <div className="notification is-danger mt-3">
            <div className="is-flex is-align-items-center">
              <Icon icon="times" className="mr-2" />
              <span>{barcodeResults.error}</span>
            </div>
          </div>
        )}

        {barcodeResults && !barcodeResults.error && (
          <div className="mt-3">
            <p className="mb-3 has-text-weight-bold">
              Found {barcodeResults.length} {barcodeResults.length === 1 ? "credit" : "credits"} with code "{barcode}"
            </p>

            <div className="columns is-multiline">
              {barcodeResults.map(credit => (
                <div key={credit.id} className="column is-6">
                  <PrepaidCreditCard credit={credit} />
                </div>
              ))}
            </div>
          </div>
        )}
      </Card>
    </div>
  );
};

export default CheckBarcodeTab;
